/* Shared structural contract; no address, origin or execution-mode defaults. */
function configurationError(reason) {
  const error = new Error(`Backend configuration error: ${reason}`);
  error.code = "BACKEND_CONFIG_INVALID";
  return error;
}

function readBackendUrl(raw, mode) {
  if (!["production", "development", "test"].includes(mode)) {
    throw configurationError("an explicit execution mode is required.");
  }
  if (typeof raw !== "string" || !raw.trim()) {
    throw configurationError("REACT_APP_BACKEND_URL is required.");
  }
  let url;
  try { url = new URL(raw); } catch (_) {
    throw configurationError("REACT_APP_BACKEND_URL must be an absolute HTTP(S) origin.");
  }
  if (!/^https?:\/\//.test(raw) || raw !== url.origin || url.username || url.password) {
    throw configurationError("provide a canonical HTTP(S) origin without user information, path, query or fragment.");
  }
  if (mode === "production" && (
    url.protocol !== "https:" || !url.hostname.includes(".") ||
    /^\d+(?:\.\d+){3}$/.test(url.hostname) || url.hostname.includes(":")
  )) {
    throw configurationError("Production requires an explicit HTTPS DNS origin.");
  }
  return raw;
}

module.exports = { readBackendUrl, configurationError };